"use client";
import { useEffect, useState } from "react";
import { Button } from "@/components/tailwind/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/tailwind/ui/dialog";
import { Shield, Settings } from "lucide-react";

const STORAGE_KEY = "openai_api_key";

export default function SettingsButton() {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState("");

  useEffect(() => {
    try {
      const v = window.localStorage.getItem(STORAGE_KEY) ?? "";
      setValue(v);
    } catch {}
  }, [open]);

  const save = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, value.trim());
      setOpen(false);
    } catch {}
  };

  const clear = () => {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
      setValue("");
    } catch {}
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" className="gap-2">
          <Settings className="h-4 w-4" />
          Settings
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Shield className="h-4 w-4" /> Bring Your Own Key
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <p className="text-sm text-muted-foreground">
            Your OpenAI API key is stored locally in your browser. It is only sent with requests you make from this page and is never persisted on our servers.
          </p>
          <div className="space-y-1">
            <label htmlFor="openaiKey" className="text-sm font-medium">
              OpenAI API Key
            </label>
            <input
              id="openaiKey"
              type="password"
              placeholder="sk-..."
              value={value}
              onChange={(e) => setValue(e.target.value)}
              autoComplete="off"
              className="w-full rounded-md border bg-background px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-ring"
            />
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <Button variant="ghost" onClick={clear}>
              Clear
            </Button>
            <Button onClick={save}>Save</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
